module.exports = Object.getOwnPropertyDescriptor